import { useCallback, useEffect, useState } from "react";
import { getSVCUploadHistory } from "../../API/svcUploadHistory.Api";
//import config from "../../../config";

export const useUploadHistory = () => {
    const [uploadHistory, setUploadHistory] = useState([]);
    const [page, setPage] = useState(0);
    const [loading, setLoading] = useState(true);
   
    console.log(uploadHistory);

    const fetchUploadHistory = useCallback(async () => {
        // console.log("page fetchUploadHistory", page)
        try{

            const data = await getSVCUploadHistory();

            // Normalize response: API might return an array or an object with `content` array
            const items = Array.isArray(data) ? data : (data && Array.isArray(data.content) ? data.content : []);

            setUploadHistory(items);

            // Stop loader when we have data or when there is no data
            if ((items && items.length > 0) || (items && items.length === 0)) {
                setLoading(false);
            }

            // setTotalPages(data.totalPages || config.amountPages);
            // setTotalPages(29);
        }catch (error) {
            console.error("Error fetching upload history:", error); 
            // stop loader on error as well
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchUploadHistory();
    }, [fetchUploadHistory]);

    return {
        fetchUploadHistory,
        uploadHistory,
        page,
        setPage,
        loading
    };
};
